const shopTitle = (state = "", action) => {
    switch(action.type) {
        case 'shopTitle':
            return action.payload;
        default:
            return state;
    }
}

export default shopTitle;